import {useSelector} from "react-redux";

export default function () {
    const isVerticalScrollComplete = useSelector(state => state.utility.isVerticalScrollComplete);
    return { isVerticalScrollComplete };
}